import React from "react";
import { Row, Col } from "react-bootstrap";
import { Bar, Line, Pie } from "react-chartjs-2";

// Import Chart.js and register required components
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register Chart.js components globally
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);
export default function DashboardView() {
   // Mock Data
  const dashboardCards = [
    { title: "Total Booking", count: 120, color: "#3498db" },
    { title: "Pending Booking", count: 40, color: "#f39c12" },
    { title: "Resolved Booking", count: 65, color: "#2ecc71" },
    { title: "Accepted Booking", count: 15, color: "#9b59b6" },
  ];

  // Chart Data
  const barData = {
    labels: dashboardCards.map((c) => c.title),
    datasets: [
      {
        label: "Complaints",
        data: dashboardCards.map((c) => c.count),
        backgroundColor: dashboardCards.map((c) => c.color),
        borderRadius: 8,
      },
    ],
  };

  const pieData = {
    labels: dashboardCards.map((c) => c.title),
    datasets: [
      {
        data: dashboardCards.map((c) => c.count),
        backgroundColor: dashboardCards.map((c) => c.color),
        hoverOffset: 10,
      },
    ],
  };

  const lineData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
      {
        label: "Complaints per Month",
        data: [100, 120, 90, 140, 160, 130],
        backgroundColor: "rgba(52,152,219,0.2)",
        borderColor: "#3498db",
        borderWidth: 2,
        tension: 0.4,
        fill: true,
        pointBackgroundColor: "#3498db",
        pointRadius: 5,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: "top", labels: { boxWidth: 20, padding: 15 } },
      tooltip: {
        backgroundColor: "#2c3e50",
        titleColor: "#fff",
        bodyColor: "#fff",
        padding: 10,
        cornerRadius: 6,
      },
    },
    scales: {
      y: { beginAtZero: true, grid: { color: "#eee" } },
      x: { grid: { display: false } },
    },
  };

  return (
    <div
      className="dashboard-container"
      style={{
        background: "#f5f7fa",
        minHeight: "100vh",
        padding: "30px",
      }}
    >
      {/* Header */}
      <h3 className="fw-bold text-primary mb-3"> Dashboard</h3>
      <p className="text-muted mb-4">
        Overview of Booking and operational statistics
      </p>

      {/* Dashboard Cards */}
      <div
        className="dashboard-cards"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
          marginBottom: "40px",
        }}
      >
        {dashboardCards.map((card, index) => (
          <div
            key={index}
            className="card"
            style={{
              flex: "1 1 250px",
              background: "#fff",
              padding: "25px 20px",
              borderRadius: "12px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              borderLeft: `5px solid ${card.color}`,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
            }}
          >
            <h3 style={{ color: card.color, fontWeight: 700, fontSize: "2rem" }}>
              {card.count}
            </h3>
            <p style={{ color: "#555", fontWeight: 500 }}>{card.title}</p>
          </div>
        ))}
      </div>

      {/* Charts Section */}
      <Row className="g-4">
        {/* Bar Chart */}
        <Col md={6}>
          <div
            className="chart-container"
            style={{
              background: "#fff",
              padding: "25px",
              borderRadius: "12px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              height: "400px",
            }}
          >
            <h5 className="fw-semibold mb-3 text-secondary">
              Booking Overview
            </h5>
            <Bar data={barData} options={chartOptions} />
          </div>
        </Col>

        {/* Pie Chart */}
        <Col md={6}>
          <div
            className="chart-container"
            style={{
              background: "#fff",
              padding: "25px",
              borderRadius: "12px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              height: "400px",
            }}
          >
            <h5 className="fw-semibold mb-3 text-secondary">
              Booking Distribution
            </h5>
            <Pie data={pieData} options={chartOptions} />
          </div>
        </Col>
      </Row>

      {/* Line Chart */}
      <Row className="mt-4">
        <Col>
          <div
            className="chart-container"
            style={{
              background: "#fff",
              padding: "25px",
              borderRadius: "12px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              height: "420px",
            }}
          >
            <h5 className="fw-semibold mb-3 text-secondary">
              Monthly Booking Trend
            </h5>
            <Line data={lineData} options={chartOptions} />
          </div>
        </Col>
      </Row>
    </div>
  );
}